var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: !_vm.dataForm.id ? "新增" : "修改",
        "close-on-click-modal": false,
        visible: _vm.visible,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: { model: _vm.dataForm, "label-width": "160px" },
          nativeOn: {
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              return _vm.dataFormSubmit()
            },
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "数据源名称", prop: "title" } },
            [
              _c("el-input", {
                attrs: { placeholder: "数据源名称" },
                model: {
                  value: _vm.dataForm.title,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataForm, "title", $$v)
                  },
                  expression: "dataForm.title",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "JDBC URL", prop: "url" } },
            [
              _c("el-input", {
                attrs: { type: "textarea", placeholder: "JDBC URL", rows: 5 },
                model: {
                  value: _vm.dataForm.url,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataForm, "url", $$v)
                  },
                  expression: "dataForm.url",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "用户名", prop: "username" } },
            [
              _c("el-input", {
                attrs: { placeholder: "用户名" },
                model: {
                  value: _vm.dataForm.username,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataForm, "username", $$v)
                  },
                  expression: "dataForm.username",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "密码", prop: "password" } },
            [
              _c("el-input", {
                attrs: {
                  type: "password",
                  "show-password": "",
                  placeholder: "密码",
                  "auto-complete": "new-password",
                },
                model: {
                  value: _vm.dataForm.password,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataForm, "password", $$v)
                  },
                  expression: "dataForm.password",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  staticStyle: { float: "right" },
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.dataFormSubmit()
                    },
                  },
                },
                [_vm._v("测试连接")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.save()
                },
              },
            },
            [_vm._v("确定")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }